import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import {
  ChangePasswordModalComponent,
  ChangePasswordData,
} from '../../shared/components/ui/change-password-modal/change-password-modal.component';
import { AuthService } from '../../core/services/auth.service';
import { UsersService } from '../../shared/services/users.service';
import { User } from '../../shared/models/auth.model';

@Component({
  selector: 'app-account-settings',
  standalone: true,
  imports: [
    CommonModule,
    ChangePasswordModalComponent,
  ],
  templateUrl: './account-settings.component.html',
  styleUrl: './account-settings.component.scss',
})
export class AccountSettingsComponent implements OnInit {
  // User data
  currentUser: User | null = null;

  // Modal state
  showChangePasswordModal: boolean = false;
  isLoading: boolean = false;
  errorMessage: string = '';
  successMessage: string = '';

  constructor(
    private authService: AuthService,
    private usersService: UsersService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUser();
  }

  onChangePassword(): void {
    this.showChangePasswordModal = true;
  }

  onPasswordChangeSubmit(data: ChangePasswordData): void {
    this.isLoading = true;
    this.errorMessage = '';
    this.successMessage = '';

    this.usersService.resetAccountPassword(
      '',
      data.oldPassword,
      data.newPassword,
      ''
    ).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.successMessage = 'Password changed successfully!';
        this.showChangePasswordModal = false;
        
        // Log out user and redirect to login page after a short delay
        setTimeout(() => {
          this.authService.logout();
          this.router.navigate(['/sign-in']);
        }, 1500);
      },
      error: (error) => {
        this.isLoading = false;
        this.errorMessage = error.error?.message || 'Failed to change password. Please try again.';
      }
    });
  }

}
